module.exports = __webpack_public_path__ + "media/images/svg/hush-text-logo-28cd54f16203c8fd7fbfd9f98a147b1d.svg";